import {validateLength} from "../functions/length";
import {createValidator} from "../validate";

export const passwordValidator = createValidator(
    validateLength(8, 255),
    // TODO: その他の条件(複雑性とか）
);
